import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const wufoo = defineConnector({
  identifier: "wufoo",
  name: "Wufoo",
  tagLine: "Online form builder",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://.*\\.wufoo\\.com/.*",
  auth: (app) =>
    basicAuth({
      username: app.secret.apiKey,
      password: "not-needed",
    }),
  steps: [
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "Log in to [Wufoo](https://www.wufoo.com/) and navigate to **More → API Information** to find your API key.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "Subdomain",
          required: true,
          placeholder: "yourcompany",
          target: { kind: "configuration", field: "subdomain" },
          helperText:
            "Your Wufoo subdomain (e.g., yourcompany from yourcompany.wufoo.com).",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ subdomain }) =>
      `https://${subdomain}.wufoo.com/api/v3/forms.json`,
  },
  publicEnvVars: ({ subdomain }) => ({
    WUFOO_URL: subdomain ? `https://${subdomain}.wufoo.com` : "",
  }),
});
